<template>
  <v-app :dark="this.$store.state.high_contrast" :vuetifyTheme="vuetifyTheme">
    <rLoadingOverlay scroll-threshold="1" scroll-off-screen="false" />
    <rMessageOverlay scroll-threshold="1" scroll-off-screen="false" />
    <rTicketOverlay scroll-threshold="1" scroll-off-screen="false" />
    <div class="bg-image" :style="backgroundStyle"></div>
    <v-toolbar
      app
      dense
      fixed
      style="z-index: 3;"
      v-if="globals && (globals[0].languages || globals[0].accessibility)"
    >
      <rLanguagePicker scroll-threshold="1" scroll-off-screen="false" :globals="globals[0]" />
    </v-toolbar>
    <v-content>
      <router-view v-if="globals" :globals="globals[0]"></router-view>
    </v-content>
      
    <offline @detected-condition="handleConnectivityChange"></offline>
  </v-app>
</template>

<script>
import Utilities from "../mixins/utilities";
import RemoteData from "../mixins/remotedata";
import NProgress from "nprogress";

export default {
  name: "App",
  data: function() {
    return {
      lastConnState : true,
      Niebieski: {
        primary: "#2196f3",
        secondary: "#2196f3",
        accent: "#f3de21",
        error: "#2196f3",
        info: "#2196f3",
        success: "#2196f3",
        warning: "#2196f3"
      },
      Czerwony: {
        primary: "#FF0000",
        secondary: "#ffe25e",
        error: "#FF0000",
        info: "#FF0000",
        success: "#FF0000",
        warning: "#FF0000"
      },
      Zielony: {
        primary: "#00cc0e",
        secondary: "#5eff69",
        accent: "#f3de21",
        error: "#00cc0e",
        info: "#00cc0e",
        success: "#00cc0e",
        warning: "#00cc0e"
      },
      PGNiG: {
        primary: "#263049",
        secondary: "#ff8400",
        accent: "#FE6309",
        error: "#FF0000",
        info: "#263049",
        success: "#4CAF50",
        warning: "#ffe100",
      }
    };
  },
  mixins: [Utilities, RemoteData({ globals: env.apiLinks.globals })],
  computed: {
    backgroundStyle: function() {
      if (this.globals && this.globals[0].bgimage) {
        return {
          background:
            "url(" +
            env.imagesPATH.upload +
            this.globals[0].bgimage +
            ") no-repeat center center fixed"
        };
      } else {
        return "";
      }
    },
    vuetifyTheme: function(){
      if (this.globals && this.globals[0].theme) {
        this.$vuetify.theme = this[this.globals[0].theme];
        return this[this.globals[0].theme];
      }else{
        return "Niebieski";
      }
    }
  },
  methods: {
    handleConnectivityChange(status) {
      if(this.lastConnState && !status){
        this.showErrorMessage(-101, this.$t(-100));
      }else{
        this.hideMessage();
      }
      this.lastConnState = status;
    }
  }
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";

#app, .display-1, .display-2, .display-3, .display-4, .headline{
  font-family: 'Montserrat', sans-serif !important;
}

a{
  text-decoration: none !important;
}

.bg-image {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  filter: blur(5px);
  -webkit-filter: blur(5px);
  opacity: 0.2;
  height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

table.v-table thead th {
  font-weight: bold;
}

.no-scroll {
  overflow: hidden;
}

.router-link-active:hover,
.router-link:hover {
  text-decoration: none;
}

*,
.theme--dark.v-expansion-panel .v-expansion-panel__container,
.v-date-picker-header__value {
  color: inherit;
}

.theme--dark{
  color: yellow !important;
  text-shadow: 1px 1px black;
}

.theme--dark .blue {
  background-color: transparent !important;
  border-color: yellow !important;
}

#expansion-panel.theme--dark > li.v-expansion-panel__container.v-expansion-panel__container--active > div.v-expansion-panel__body > div > div.v-card__text > div > ul > li > a{
  color: yellow !important;
  text-shadow: 1px 1px black;
}

#expansion-panel.theme--dark > li.v-expansion-panel__container.v-expansion-panel__container--active > div.v-expansion-panel__body > div > div.v-card__text > div > ul > li > a:hover{
  color: white !important;
  text-shadow: 1px 1px black;
}

.theme--dark .blue--text {
  color: yellow !important;
}

.theme--dark .error--text,
.theme--dark .primary--text,
.theme--dark .info--text {
  color: yellow !important;
  caret-color: yellow !important;
}
.row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.jumbotron {
  padding: 1em !important;
}

.loader_container {
  border-radius: 5%;
  border: 1px solid #f3f3f3;
  padding: 1em;
  margin-top: 5px;
}

.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  margin: auto;
  animation: spin 2s linear infinite;
}

#nprogress .bar {
  height: 6px !important;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

body, html{
  margin: 0px;
  padding: 0px;
}
</style>